import axios from 'axios'

export default {

	async getColumns(API_URL,items) {
		if (items.length) {
			var url = API_URL + '?$select=' + encodeURIComponent(items.join(","));
			const { data } = await axios.get(url);
			return data;
		} else {
			throw new Error('Must pass in columns');
		}
	},

	async getResults(API_URL,params) {

		let url = API_URL + '?' + this.queryBuilder(params);
		const { data } = await axios.get(url);
		return data;
	},

	queryBuilder({where_parameters,group_parameters,order_parameters,limit_parameters,select_parameters}) {
		let query_parameters = [];
		if (where_parameters && where_parameters.length) {
			query_parameters.push(this.whereBuilder(where_parameters));
		}
		if (group_parameters && Object.keys(group_parameters).length) {
			query_parameters.push(this.groupBuilder(group_parameters));
		}
		if (order_parameters && order_parameters.length) {
			query_parameters.push(this.orderBuilder(order_parameters));
		}
		if (limit_parameters && Object.keys(limit_parameters).length) {
			query_parameters.push(this.limitBuilder(limit_parameters));
		}
		if (select_parameters && select_parameters.length) {
			query_parameters.push('$select=' + select_parameters.map(column => encodeURIComponent(column)).join(','));
		}
		return query_parameters.join('&');
	},

	limitBuilder(params) {
		//expect { limit: #, offset: #(optional)}
		let limit = '';
		if (params.limit) {
			limit += '$limit=' + params.limit;
			if (params.offset) {
				limit += '&$offset=' + params.offset;
			}
		}
		return limit;
	},

	groupBuilder(params) {
		//follows the format of:
		//{ select: [array] (for select),
		//group: ['columns'],
		//function_column: 'column',
		//function: 'count / sum' }
		if (params.select && params.select.length && params.group) {
			let group_str = '$select=' + encodeURIComponent(params.select.join(","));
			if (params.function) {
				group_str += "," + params.function + '(' + encodeURIComponent(params.function_column) + ')';
			}
			group_str += "&$group=" + encodeURIComponent(params.group.join(","));
			return group_str;
		}
		return '';
	},

	orderBuilder(params) {
		//[ array of orders ]
		//{ order has a key and a direction }
		if (params.length) {
			return '$order=' + params.map(param => param.key + ' ' + param.direction + ' nulls last').join(', ');
		}
		return '';
	},

	whereBuilder(where_parameters) {
		//follows the format of:
		//[ array of search items to be "anded" ]
		//[ array of search items to be "or'd" ]
		//{ search item showing column: column name, type: LIKE or the type of check (=,<,>), and params: [parameters to be "or'd"]}
		let and_parts = [];
		for (var idx in where_parameters) {
			let search_items = where_parameters[idx];

			let or_parts = [];
			for (var ydx in search_items) {
				let search_item_text = this.buildSearchItem(search_items[ydx]);
				if (search_item_text) {
					or_parts.push(search_item_text);
				}
			}
			if (or_parts.length) {
				if (or_parts.length === 1) {
					and_parts.push(or_parts[0]);
				} else {
					and_parts.push("(" + or_parts.join("%20OR%20") + ")");
				}
			}
		}
		if (and_parts.length) {
			return '$where=' + and_parts.join("%20AND%20");
		}
		return '';
	},

	buildSearchItem(search_item) {
		let parts = '';
		if (search_item.type) {
			let item_parts = [];
			if (search_item.type==='LIKE') {
				item_parts = search_item.params.map(item => 'upper(' + search_item.column +') %20LIKE%20"%25' + encodeURIComponent(item).toUpperCase() + '%25"');
			} else if (search_item.type==='NOTNULL') {
				item_parts = [search_item.column + ' IS NOT NULL'];
			} else if (search_item.type==='NULL') {
				item_parts = [search_item.column + ' IS NULL'];
			} else {
				item_parts = search_item.params.map(item => search_item.column + ' ' + search_item.type + ' "' + encodeURIComponent(item) + '"');
			}
			if (item_parts.length === 1) {
				parts = item_parts[0];
			} else {
				parts = "(" + item_parts.join("%20OR%20") + ")";
			}
		}
		return parts;
	}
}
